import {
    DATIQ_DEFAULT_BOOLEAN,
    DATIQ_DEFAULT_ID,
} from '@dat/datiq-core/models';
import {
    DATIQ_PANEL_POPUP_DEFAULT_ICON,
    DATIQ_PANEL_POPUP_DEFAULT_ICON_CLOSE,
    DatiqPanelPopupPosition,
    IDatiqPanelPopup,
} from '../../../models';

export const emptyDatiqPanelPopup: IDatiqPanelPopup = {
    id: DATIQ_DEFAULT_ID('panel-popup'),
    icon: DATIQ_PANEL_POPUP_DEFAULT_ICON,
    closeIcon: DATIQ_PANEL_POPUP_DEFAULT_ICON_CLOSE,
    closeOnEsc: DATIQ_DEFAULT_BOOLEAN,
    closeOnOutsideClick: DATIQ_DEFAULT_BOOLEAN,
    opened: DATIQ_DEFAULT_BOOLEAN,
    position: DatiqPanelPopupPosition.LeftBottom,
};
